import { Component, OnInit, Input } from '@angular/core';
import { IPatient } from '@ahryman40k/ts-fhir-types/lib/R4';
import { Router } from '@angular/router';

@Component({
  selector: 'inc-patient-list',
  templateUrl: './patient-list.component.html',
  styleUrls: ['./patient-list.component.scss'],
})
export class PatientListComponent implements OnInit {

  @Input() patientList: IPatient[];

  constructor(private router: Router) { }

  ngOnInit() { }

  stopProp(event: Event) {
    event.stopPropagation();
  }

  navigateTo(url: string, patient: any, event?: Event, ) {
    if (event) {
      event.stopPropagation();
    }
    localStorage.removeItem('patient');
    this.router.navigateByUrl(url, { state: { parameter: patient } });
  }
}
